import React, { useEffect, Fragment, useState } from "react";
import Pagination from "../../components/NewPagination";
import {
  ButtonBase,
  Button,
  InputAdornment,
  TextField,
  Card,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  CircularProgress,
  Switch,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import "./index.css";
import SearchIcon from "@mui/icons-material/Search";

const CardData = ({
  isLoading,
  data,
  dataFilter,
  totalDataRecord,
  onChangePage,
  handleUpdate,
}) => {
  console.log("Card Data Filter:", dataFilter);

  return (
    <Card className="table-card">
      <div className="table-title mb-2">
        <span>Gift Cards</span>
        <div>
          <TextField
            fullWidth
            variant="standard"
            className="search-input"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ color: "white" }} />
                </InputAdornment>
              ),
            }}
            onChange={(e) => onChangePage("search", e.target.value)}
            value={dataFilter?.search || ""}
          />
        </div>
      </div>
      <div className="gift-cards-table-container mt-5">
        {isLoading ? (
          <div className="flex justify-center items-center p-4">
            <CircularProgress />
          </div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Rate</th>
                <th>Category</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {data &&
                data.length > 0 &&
                data.map((card) => (
                  <tr key={card._id}>
                    <td>{card._id}</td>
                    <td>{card.name}</td>
                    <td>{card.rate}</td>
                    <td>{card.category?.name}</td>
                    <td>{card.status === "active" ? "Active" : "Inactive"}</td>
                    <td>
                      <Switch
                        checked={card.status === "active" ? true : false}
                        onChange={() => handleUpdate(card._id, card.status)}
                        color="primary"
                        disabled={isLoading}
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        )}
      </div>
      <div className="gift-cards-pagination-container">
        <Pagination
          items={totalDataRecord}
          initialPage={dataFilter?.page}
          onChangePage={onChangePage}
          per_page={dataFilter?.limit}
        />
      </div>
    </Card>
  );
};
export default CardData;
